import { Component, Inject, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { OutboxMessageAdvancedSearchRequest } from "src/app/core/api/models";

import { ExcelService } from "src/app/core/api/services";
import { DynamicTabService } from "src/app/core/services/dynamic-tab.service";
import { BaseDownloadExcelPageComponent } from "src/app/pages/shared/base/components/base-download-excel-page.component";

@Component({
    selector: "app-create-outbox-messages-excel-dialog",
    templateUrl: "./create-outbox-messages-excel-dialog.component.html",
    styles: [``],
    standalone: false
})
export class CreateOutboxMessagesExcelDialogComponent
  extends BaseDownloadExcelPageComponent
  implements OnInit
{
  //#region properties
  dynamicTabService = inject(DynamicTabService);

  body: OutboxMessageAdvancedSearchRequest;
  excelTypes: any;
  organizationId: number;
  isMoreDetailType: boolean = false;
  //#endregion

  constructor(
    protected currentService: ExcelService,
    protected dialogRef: MatDialogRef<CreateOutboxMessagesExcelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.comparisonObjects = data?.comparisonObjects;
    this.sortObject = data?.sortObject;
    this.body = data?.body;
    this.excelTypes = data?.excelType;
    this.organizationId = data?.organizationId;
    this.isMoreDetailType = data?.isMoreDetailType;
  }

  //#region Api

  getExcel() {
    this.unSubs();
    this.loading = true;
    if (!this.isMoreDetailType)
      this.currentService
        .excelCreateOutboxMessagesExcelPost({
          body: {
            title: this.title,
            comparisonObjects: this.comparisonObjects,
            orders: this.sortObject,
            description: this.body?.description,
            smsText: this.body?.smsText,
            endDate: this.body?.endDate,
            guild: this.body?.guild,
            phonebookIds: this.body?.phonebookIds,
            startDate: this.body?.startDate,
            toNumber: this.body?.toNumber,
            zipCode: this.body?.zipCode,
            zone: this.body?.zone,
            excelTypes: this.excelTypes,
            organizationId: this.organizationId ? this.organizationId : 0,
          },
        })
        .pipe(this.basePipeOperators())
        .subscribe(this.baseDownloadExcelObserver);
    else
      this.currentService
        .excelCreateOutboxMessagesExcelWithSeparatedDeliveryColumnsPost({
          body: {
            title: this.title,
            comparisonObjects: this.comparisonObjects,
            orders: this.sortObject,
            description: this.body?.description,
            smsText: this.body?.smsText,
            endDate: this.body?.endDate,
            guild: this.body?.guild,
            phonebookIds: this.body?.phonebookIds,
            startDate: this.body?.startDate,
            toNumber: this.body?.toNumber,
            zipCode: this.body?.zipCode,
            zone: this.body?.zone,
            excelTypes: this.excelTypes,
            organizationId: this.organizationId ? this.organizationId : 0,
          },
        })
        .pipe(this.basePipeOperators())
        .subscribe(this.baseDownloadExcelObserver);
  }

  //#endregion
}
